import { type RoomState } from '../models/RoomState'
import { type MinGroupSizeIssue } from '../types'

/**
 * Validates a room state against the minimum group size requirement.
 * Returns an issue if the group has users but doesn't meet the minimum.
 * Returns null if no minimum is enforced (minGroupSize <= 1) or if the requirement is met.
 */
export function getMinGroupSizeIssue({
  roomState,
  minGroupSize,
}: {
  roomState: RoomState
  minGroupSize: number
}): { issue: MinGroupSizeIssue; min: number } | null {
  // No minimum enforced if minGroupSize is 1 or less
  if (minGroupSize <= 1) return null

  // Don't flag empty groups - they have other issues
  if (!roomState.userCount) return null

  // Check if the group meets the minimum
  if (roomState.userCount < minGroupSize) {
    return { issue: 'belowMinGroupSize', min: minGroupSize }
  }

  return null
}
